import { render, staticRenderFns } from "./Assign.vue?vue&type=template&id=287a8fba&"
import script from "./Assign.vue?vue&type=script&lang=js&"
export * from "./Assign.vue?vue&type=script&lang=js&"
import style0 from "./Assign.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports